import * as React from "react";

import { Table as CoreTable, ITableProps as ICoreTableProps } from "@webbio/components";
import defaultStyles from "./table.module.scss";

export interface ITableProps extends ICoreTableProps {
  /** Disables the row hover effect (background + pointer). */
  noHover?: boolean;
}

const Table = ({ noHover, ...props }: ITableProps): JSX.Element => {
  const table = <CoreTable {...props} propStyles={defaultStyles} />;

  // Only wrap when needed, so existing tables keep their exact DOM.
  return noHover ? <div className={defaultStyles.noHover}>{table}</div> : table;
};

export { Table };
